// Components
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import InputSwitch from 'primevue/inputswitch'
import ProgressSpinner from 'primevue/progressspinner'
import HeaderCustom from '@/views/components/header/HeaderHjpTable.vue'
import Paginator from '@/views/components/paginator/Paginator.vue'
import ListActions from '@/views/components/list/ListActions.vue'
import HjpSideBar from '@/views/components/sidebar/HjpSideBar.vue'
import HjpCofirmModal from '@/views/components/modal/HjpConfirmationModal.vue'
import HjpDefaultModal from '@/views/components/modal/ModalDefault.vue'
import Card from 'primevue/card'
import OverlayPanel from 'primevue/overlaypanel'

import { onMounted, reactive, ref, toRefs, defineComponent, computed, PropType, getCurrentInstance, watch } from 'vue'
import apiUseCase from '@/usecase/apiUseCase'
import $ from 'jquery'
import {
  useStore
} from 'vuex'
import '@/views/components/table/hjp-data-table.scss'
import {
  IConfirmDialogDelete,
  IObjectOfColumns
} from '@/utils/interfaces/iHjpDataTable'
import {
  get
} from 'lodash'
import IResponse from '@/utils/interfaces/iResponse'
import EmptyState from '@/views/components/list/EmptyState.vue'
import { useRouter } from 'vue-router'
import { encryptDecriptMethods } from '@/plugins/encryptDecriptMethods'
import numberFormat from '@/utils/helpers/numberFormat'

const moduleStore = 'hjpTable'

export default defineComponent({
  components: {
    DataTable,
    Column,
    HeaderCustom,
    Paginator,
    ListActions,
    HjpSideBar,
    InputSwitch,
    HjpCofirmModal,
    ProgressSpinner,
    Card,
    OverlayPanel,
    EmptyState,
    HjpDefaultModal
    // Row
  },
  props: {
    columns: {
      type: Array as PropType<IObjectOfColumns[]>,
      default: () => [],
    },
    endpoint: {
      type: String,
      default: () => '',
    },
    endpointSearch: {
      type: String,
      default: () => ''
    },
    // Character yg ditampilkan ketika data kosong
    emptyTable: {
      default: () => 'Data belum ada, silahkan tambah untuk mengisi data',
    },
    // Menampilkan kolom action
    showAction: {
      type: Boolean,
      default: () => true
    },
    headerTitle: {
      type: String,
      default: () => 'New Page'
    },
    buttonTitle: {
      type: String,
      default: () => 'Tambah'
    },
    // Character yg ditampilkan untuk placeholder search
    searchPlaceholder: {
      type: String,
      default: 'Cari Disini...'
    },
    isEdit: {
      type: Boolean,
      default: true
    },
    isEditFuelPrice: {
      type: Boolean,
      default: false
    },
    isChange: {
      type: Boolean,
      default: false
    },
    isDelete: {
      type: Boolean,
      default: true
    },
    isFuelQrCode: {
      type: Boolean,
      default: false
    },
    isVerifyFuelCoupon: {
      type: Boolean,
      default: false
    },
    hasCustomAction: {
      type: Boolean,
      default: false
    },
    editTitle: {
      type: String,
      default: ''
    },
    changeTitle: {
      type: String,
      default: ''
    },
    deleteTitle: {
      type: String,
      default: ''
    },
    fuelQrCodeTitle: {
      type: String,
      default: 'Tampilkan QR Code'
    },
    // Untuk menampilkan form di halaman Baru
    isOpenNewPage: {
      type: Boolean,
      default: false
    },
    isOpenNewPageForm: {
      type: Boolean,
      default: false
    },
    pageFormRoute: {
      type: String,
      default: ''
    },
    // Berisi atribute yg digunakan untuk mengisi content Confirm Dialog
    confirmDialogDelete: {
      type: Object as PropType<IConfirmDialogDelete>,
      default: () => ({
        imgContent: require('@/assets/img/modal-confirmation/delete-default.svg'),
      })
    },
    confirmDialogVerifyFuelCoupon: {
      type: Object as PropType<IConfirmDialogDelete>,
      default: () => ({
        imgContent: require('@/assets/img/modal-confirmation/fuel-coupon-verify.png'),
      })
    },
    // Menampilkan colom aktif
    showColumnActivate: {
      type: Boolean,
      default: false
    },
    showBtnAdd: {
      type: Boolean,
      default: true
    },
    showSearch: {
      type: Boolean,
      default: true
    },
    endpointSuffix: {
      type: String,
      default: ''
    },
    orderBy: {
      type: String,
      default: ''
    }
  },
  emits: ['rowSelected'],
  setup(props: any, { emit }: any) {
    const app = getCurrentInstance()
    const {
      $toast, $strInd
    } = app!.appContext.config.globalProperties
    const store = useStore()
    const router = useRouter()
    const dataSource = ref([])
    const { columns, emptyTable, endpoint, confirmDialogDelete, confirmDialogVerifyFuelCoupon, endpointSuffix, isChange, isOpenNewPageForm, pageFormRoute, orderBy } = toRefs(props)
    //   confirmDialogDelete.value.imgContent = require('@/assets/img/modal-confirmation/delete-default.svg')
    // const headerCustom = ref()
    // const dateColumns = ref(columns.map((x:)))
    const paginate = reactive({
      pageSize: 10,
      pageNumber: 1,
      totalRecords: 0,
    })
    const orderByTable = ref(orderBy.value)
    const formIndex = ref(0)
    const dataRow = ref(null) as any
    const isLoading = ref(false)
    const searchCharacter = ref('')
    const refOverlayAction = ref()
    const showConfirmDialog = ref(false)
    const showConfirmVerifyFuelCouponDialog = ref(false)
    const isChangeForm = ref(isChange.value)
    const isDialogHasTitle = ref(false)

    // const sidebarCanDelete = ref(store.state[moduleStore].rightbarForm.canDelete)
    // const isReloadTable = store.state[moduleStore].reloadTable
    const showModalForm = computed({
      get: () => store.state[moduleStore].modal.show,
      set: (value) => {
        store.dispatch('setShowModal', value)
      }
    })
    const showDialogForm = computed({
      get: () => store.state[moduleStore].dialog.show,
      set: (value) => {
        store.dispatch('setShowDialog', value)
      }
    })
    const sidebarCanDelete = computed({
      get: () => store.state[moduleStore].rightbarForm.canDelete,
      set: (value) => {
        store.dispatch('setToggleDatatableSidebarDeleteButton', value)
      }
    })
    const hideOverlay = () => {
      refOverlayAction.value.hide()
    }
    const hideModalForm = () => {
      showModalForm.value = false
    }
    const hideDialogForm = () => {
      showDialogForm.value = false
    }
    const setDataRowOnState = async () => {
      // console.log('dataRow', dataRow.value)
      await store.dispatch('storeRowDataTable', dataRow.value)
    }
    const getData = () => {
      isLoading.value = true
      const arrParams = []
      let paramsString = ''
      const columnsSearch = columns.value.filter((column: IObjectOfColumns) => column.searchable === true)
      if (searchCharacter.value && columnsSearch.length > 0) {
        columnsSearch.forEach((column: IObjectOfColumns) => {
          if (column.fieldSearch) {
            if (column.fieldSearch === 'q') {
              if (arrParams.length < 1) {
                arrParams.push(`${column.fieldSearch}=${searchCharacter.value}`)
              }
            } else {
              arrParams.push(`${column.fieldSearch}=${searchCharacter.value}`)
            }
          }
        })
      }
      if (paginate.pageSize > 0) {
        arrParams.push(`pageSize=${paginate.pageSize}`)
      }
      if (paginate.pageNumber > 0) {
        arrParams.push(`pageNumber=${paginate.pageNumber}`)
      }
      if (orderByTable.value) {
        arrParams.push(`orderBy=${encodeURIComponent(orderByTable.value)}`)
      }
      paramsString = `?${arrParams.join('&')}`
      let fixEndpoint = endpoint.value
      if (endpointSuffix.value) {
        fixEndpoint = `${fixEndpoint}${endpointSuffix.value}`
      }
      apiUseCase.get(`${fixEndpoint}${paramsString}`).then((response) => {
        // console.log('response', response)
        const {
          result,
          pagesize,
          count
        } = response
        dataSource.value = result
        paginate.pageSize = pagesize
        paginate.totalRecords = count
        isLoading.value = false
      }).catch((err: any) => {
        isLoading.value = false
      })
    }
    const onSort = (val: any) => {
      // console.log('onSort', val)
      paginate.pageNumber = 1
      orderByTable.value = `${val.sortField} ${val.sortOrder === 1 ? 'asc' : 'desc'}`
      getData()
    }
    const onChangePage = (event: any) => {
      // console.log('onChangePage', event)
      paginate.pageNumber = event.page + 1
      // console.log('obj pagin', paginate)
      getData()
      const container = $('.wrap-hjp-data-table')
      $(window).scrollTop(container.offset().top)
      // $(window).animate({ scrollTop: 0 }, 3000)
    }
    const onSearch = (value: string) => {
      searchCharacter.value = value
      getData()
    }
    const showDropDown = (evt: any, item: any) => {
      dataRow.value = item
      emit('rowSelected', dataRow.value)
      // console.log('dataRow', dataRow.value)
      isChangeForm.value = dataRow.value.Trayek ? true : false
      // console.log('isChange', isChangeForm.value)
      refOverlayAction.value.toggle(evt)
    }
    const onDelete = (val: any) => {
      showConfirmDialog.value = true
      showConfirmVerifyFuelCouponDialog.value = false
      setDataRowOnState()
      hideOverlay()
    }
    const onVerifyFuelCoupon = (val: any) => {
      confirmDialogVerifyFuelCoupon.value.subTitle = `Apakah Anda yakin ingin meng-approve kupon <span class="font-bold">${dataRow.value?.Code}</span> untuk pembelian <span class="font-bold">${dataRow.value?.FuelingTypeDisplayName} ${dataRow.value?.FuelingType !== 'FullTank' ? `${numberFormat(dataRow.value?.LitersQty ?? 0)}L` : ''} - ${dataRow.value?.FuelTypeDisplayName}</span>?`
      showConfirmDialog.value = false
      showConfirmVerifyFuelCouponDialog.value = true
      setDataRowOnState()
      hideOverlay()
    }
    const onEdit = (val: any) => {
      if (isOpenNewPageForm.value) {
        router.push({
          name: pageFormRoute.value,
          params: { id: encryptDecriptMethods.encrypt(dataRow.value) }
        })
      } else {
        showModalForm.value = true
        setDataRowOnState()
        hideOverlay()
      }
    }
    const onChange = (val: any) => {
      // formIndex.value = 1
      showDialogForm.value = true
      setDataRowOnState()
      hideOverlay()
    }
    const onShowQrCode = async (val: any) => {
      // formIndex.value = 1
      await setDataRowOnState()
      showDialogForm.value = true
      hideOverlay()
    }
    const onClickBtnAdd = () => {
      // console.log('isOpenNewPageForm', isOpenNewPageForm.value)
      if (isOpenNewPageForm.value) {
        router.push({
          name: pageFormRoute.value
        })
      } else {
        store.dispatch('flushRowDataTable')
        showModalForm.value = true
      }
    }
    const hideDialogConfirmation = () => {
      store.dispatch('flushRowDataTable')
      showConfirmDialog.value = false
      showConfirmVerifyFuelCouponDialog.value = false
    }
    const submitFromDialog = (val: any = '') => {
      store.dispatch('showLoading')
      const deletedId = val === '' ? dataRow.value.Id : val
      apiUseCase.delete(endpoint.value, deletedId).then((res: IResponse) => {
        if (!res.error) {
          $toast.add({
            severity: 'success',
            detail: 'Data berhasil dihapus',
            group: 'bc',
            closable: false,
            life: 3000
          })
          getData()
        } else {
          $toast.add({
            severity: 'error',
            detail: res.message,
            group: 'bc',
            closable: false,
            life: 3000
          })
        }
      }).catch((err: any) => {
        console.log('err delete', err)
      })
      hideDialogConfirmation()
      store.dispatch('hideLoading')
    }

    const submitFromDialogVerifyFuelCoupon = (val: any = '') => {
      if (dataRow.value?.Status === 'Approved') {
        $toast.add({
          severity: 'error',
          summary: 'Kupon Sudah di-Approve!',
          detail: 'Anda sudah meng-approve kupon ini. Anda tidak bisa melakukannya lagi.',
          group: 'bc',
          closable: false,
          life: 3000
        })
      } else {
        store.dispatch('showLoading')
        const selectedId = val === '' ? dataRow.value.Id : val
        const payload = {
          Id: selectedId
        }
        apiUseCase.postWithNoId(`${endpoint.value}/${selectedId}/Approve`, payload).then((res: IResponse) => {
          if (!res.error) {
            $toast.add({
              severity: 'success',
              summary: 'Kupon BBM Berhasil di-Approve!',
              detail: `Kupon pembelian BBM ${dataRow.value?.Code} berhasil di-approve.`,
              group: 'bc',
              closable: false,
              life: 3000
            })
            getData()
          } else {
            $toast.add({
              severity: 'error',
              summary: 'Gagal Approve Kupon BBM',
              detail: res.message,
              group: 'bc',
              closable: false,
              life: 3000
            })
          }
        }).catch((err: any) => {
          console.log('err delete', err)
        })
        hideDialogConfirmation()
        store.dispatch('hideLoading')
      }
    }

    const onEditFuelPrice = () => {
      console.log('hehe')
      router.push({
        name: 'master-spbu-fuel-form',
        params: { id: encryptDecriptMethods.encrypt(dataRow.value) }
      })
    }

    const changeIsActive = async (val: any) => {
      const data = {
        // Id: val.Id,
        IsActive: val.IsActive
      }
      const response = await apiUseCase.patch(endpoint.value, val.Id, data)
      if (!response.error) {
        $toast.add({
          severity: 'success',
          detail: 'Data berhasil diubah',
          group: 'bc',
          life: 3000
        })
      } else {
        $toast.add({
          severity: 'error',
          detail: response.message,
          group: 'bc',
          life: 3000
        })
        val.IsActive = !val.IsActive
      }
    }
    onMounted(() => {
      getData()
      sidebarCanDelete.value = true
    })

    watch(() => store.getters.reloadTable, (val) => {
      if (val) {
        getData()
      }
    })

    return {
      dataSource,
      isLoading,
      emptyTable,
      paginate,
      onSort,
      showDropDown,
      onDelete,
      onEdit,
      onClickBtnAdd,
      refOverlayAction,
      showModalForm,
      hideModalForm,
      showConfirmDialog,
      hideDialogConfirmation,
      submitFromDialog,
      onChangePage,
      onSearch,
      get,
      changeIsActive,
      confirmDialogDelete,
      onChange,
      formIndex,
      sidebarCanDelete,
      showDialogForm,
      hideDialogForm,
      isChangeForm,
      onShowQrCode,
      showConfirmVerifyFuelCouponDialog,
      confirmDialogVerifyFuelCoupon,
      submitFromDialogVerifyFuelCoupon,
      onVerifyFuelCoupon,
      dataRow,
      onEditFuelPrice,
    }
  },
})
